<template>
  <div>
    <h2>Tracked games <small class="text-muted">for this version</small></h2>
    <div>
      <router-link :to="{ name: 'TrackGame' }">Track a game</router-link>
    </div>
    <div v-if="trackedGameRows === 0 && gameSummaryData.total_games <= 0">
      <em>There are no visible tracked games for this version</em>
    </div>
    <div v-if="gameSummaryData.total_games > 0">
      <h3>Summary</h3>
      <GameSummary :deckId="deckId" :gameSummaryData="gameSummaryData" />
    </div>
    <h3 v-if="trackedGameRows > 0">Details</h3>
    <GameList
      :items="getGameData"
      :rows="trackedGameRows"
      ref="trackedGames"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import GameList from "@/components/GameList.vue";
import GameSummary from "@/components/GameSummary.vue";

import api from "@/api";

export default {
  name: "DeckGamesInfo",
  components: {
    GameList,
    GameSummary,
  },
  props: {
    deckId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      trackedGameRows: -1,
    };
  },
  asyncComputed: {
    gameSummaryData: {
      async get() {
        const data = await api.getDeckGamesSummary(this.deckId);
        return data;
      },
      default: {},
    },
  },
  methods: {
    refresh() {
      this.$asyncComputed.gameSummaryData.update();
    },
    getGameData(ctx, callback) {
      api
        .getDeckGames(this.deckId, ctx)
        .then((data) => {
          this.trackedGameRows = data.total;
          callback(data.games);
        })
        .catch(() => {
          callback([]);
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
  },
};
</script>
